import { useGetTeamsQuery } from '../../../features/teams/teamsApi'

export default function Teams() {
  const { data: teams, isLoading, isError, error } = useGetTeamsQuery()
  return (
    <div className="mt-8">
      <h3 className="text-xl font-bold">Team Members</h3>
      <div className="mt-3 space-y-4">
        {teams?.length ?
          teams?.map(team => (
            <div key={team.id} className="checkbox-container">
              <img src={team.avatar} className="team-avater" />
              <p className="label">{team?.name}</p>
            </div>
          ))
          :
          <div>Teams Not Found</div>
        }
      </div>
    </div>
  )
}